import { Filter } from 'lucide-react'
import Button from '@/components/ui/Button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/SelectComponents'
import {
  STATUS_FILTER_OPTIONS,
  PAYMENT_FILTER_OPTIONS,
  APPROVAL_FEE_OUTCOME_FILTER_OPTIONS,
  DATE_RANGE_FILTER_OPTIONS,
} from '@/api/enums'

type ActiveFilter = { label: string; onRemove: () => void }

type FilterBarProps = {
  statusFilter: string
  setStatusFilter: (v: string) => void
  paymentFilter: string
  setPaymentFilter: (v: string) => void
  feeOutcomeFilter: string
  setFeeOutcomeFilter: (v: string) => void
  dateRangeFilter: string
  setDateRangeFilter: (v: string) => void
  activeFilters: ActiveFilter[]
  clearAllFilters: () => void
}

export function FilterBar({
  statusFilter,
  setStatusFilter,
  paymentFilter,
  setPaymentFilter,
  feeOutcomeFilter,
  setFeeOutcomeFilter,
  dateRangeFilter,
  setDateRangeFilter,
  activeFilters,
  clearAllFilters,
}: FilterBarProps) {
  return (
    <div className='rounded-lg border bg-card p-4'>
      <div className='mb-4 flex items-center gap-2'>
        <Filter className='h-4 w-4 text-muted-foreground' />
        <span className='text-sm font-medium text-foreground'>Filters</span>
        {activeFilters.length > 0 && (
          <Button variant='ghost' size='sm' onClick={clearAllFilters} className='ml-auto text-xs'>
            Clear All
          </Button>
        )}
      </div>

      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4'>
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger>
            <SelectValue placeholder='Appointment Status' />
          </SelectTrigger>
          <SelectContent>
            {STATUS_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={paymentFilter} onValueChange={setPaymentFilter}>
          <SelectTrigger>
            <SelectValue placeholder='Payment Status' />
          </SelectTrigger>
          <SelectContent>
            {PAYMENT_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={feeOutcomeFilter} onValueChange={setFeeOutcomeFilter}>
          <SelectTrigger>
            <SelectValue placeholder='Approval Fee Outcome' />
          </SelectTrigger>
          <SelectContent>
            {APPROVAL_FEE_OUTCOME_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={dateRangeFilter} onValueChange={setDateRangeFilter}>
          <SelectTrigger>
            <SelectValue placeholder='Date Range' />
          </SelectTrigger>
          <SelectContent>
            {DATE_RANGE_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
